<div *ngIf="loading" class="my-5 text-center">
  {{ 'Loading' | translate }}
</div>

<div *ngIf="errorKey" class="my-5 text-center">
  <p>{{ errorKey | translate }}</p>
  <button class="btn btn-primary" (click)="retry()">{{ 'Login again' | translate }}</button>
</div>
